module.exports = __webpack_public_path__ + "img/visa.5ede84a3.svg";